import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getPurchaseCreditNotes } from "api/purchaseCreditNote.api";
import { gracefulList } from "lib/queryHelpers";
import { QUERY_KEYS } from "config/queryKeys";
import { DEFAULT_STALE_TIME } from "config/constants";

const mapCreditNote = (cn) => ({
  id: cn.id || cn._id,
  vendorName: cn.vendorName || "—",
  billNumber: cn.originalBillNumber || "—",
  creditNoteNumber: cn.documentNumber,
  creditNoteDate: cn.documentDate,
  totalAmount: cn.subtotal ?? 0,
  totalVat: cn.taxAmount ?? 0,
  netAmount: cn.totalAmount ?? 0,
  status: cn.status,
  notes: cn.reason || "",
  lines: (cn.lineItems || []).map((l, i) => ({
    id: i + 1,
    description: l.description,
    qty: l.quantity,
    price: l.unitPrice,
    taxRate: l.taxRate,
  })),
  raw: cn,
});

export const useGetPurchaseCreditNotes = (params = {}) => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: QUERY_KEYS.purchaseCreditNotes.list(),
    queryFn: gracefulList(() => getPurchaseCreditNotes(params), {
      creditNotes: [],
    }),
    initialData: () =>
      queryClient.getQueryData(QUERY_KEYS.purchaseCreditNotes.list()),
    select: (data) => (data?.creditNotes || []).map(mapCreditNote),
    staleTime: DEFAULT_STALE_TIME,
  });
};
